import React, { useState, Fragment, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { getListingsAxios, getSocialLinkAxios } from "../../Actions/axios";



const Cointokenlist = () => {

  const navigate = useNavigate();
  //   const [cointokenList, setCointokenList] = useState([]);
  const [exchangeLists, setExchangeLists] = useState([]);
  console.log("exchangeListsexchangeLists", exchangeLists);

  const getExchangeList = async () => {
    let resp = await getListingsAxios({ section: "coin" });
    console.log("🚀 ~ setExchangeLists ~ resp:", resp);
    if (resp?.status) {
      setExchangeLists(resp?.data?.data);
    }
  };

  const columns = [
    {
      name: "Steps",
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <p>{record?.stepName}</p>
          </Fragment>
        );
      },
    },
    {
      name: "Action",
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <button
              className={`btn sitebtn btn-sm`}
              onClick={() => navigate("/cointokenedit", { state: record })}
            >
              <FaEdit />
            </button>
          </Fragment>
        );
      },
    },
  ];


  useEffect(() => {
    getExchangeList();
  }, []);

  return (

    <div className="cmslist">
      <h1 className="pagehead">Coin/Token Question List</h1>
      <div className="cardbox">
        <div className="d-flex align-items-center justify-content-end gap-3 mb-4">
          <Link to="/cointokenadd" className="btn sitebtn">
            Add
          </Link>
        </div>
        <div className="tablebox">
          <DataTable
            className="react-datatables"
            columns={columns}
            data={exchangeLists}
            pagination
            paginationPerPage={20}   
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
          />
        </div>
      </div>
    </div>
  );
};

export default Cointokenlist;